const AlertsPage = () => import("../views/AlertsPage.vue");

export default [
    {
        path: "/Alerts",
        name: "Alerts",
        component: AlertsPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "alerts", title: "CruzControl | Alerts" }
    },
]